// Full class strings so Tailwind keeps them. Text is the -800 shade on a -50 background (well above 4.5:1 contrast).
const PALETTE = [
  "bg-emerald-50 text-emerald-800 border-emerald-200",
  "bg-amber-50 text-amber-800 border-amber-200",
  "bg-violet-50 text-violet-800 border-violet-200",
  "bg-rose-50 text-rose-800 border-rose-200",
  "bg-orange-50 text-orange-800 border-orange-200",
  "bg-indigo-50 text-indigo-800 border-indigo-200",
  "bg-fuchsia-50 text-fuchsia-800 border-fuchsia-200",
  "bg-sky-50 text-sky-800 border-sky-200",
  "bg-stone-100 text-stone-800 border-stone-300",
];
const DOTS = ["bg-emerald-500", "bg-amber-500", "bg-violet-500", "bg-rose-500", "bg-orange-500", "bg-indigo-500", "bg-fuchsia-500", "bg-sky-500", "bg-stone-500"];
// Second round for longer lists: solid -700 badges with white text (all above 4.5:1).
const SOLID = [
  "bg-violet-700 text-white border-violet-700", "bg-rose-700 text-white border-rose-700", "bg-orange-700 text-white border-orange-700",
  "bg-indigo-700 text-white border-indigo-700", "bg-fuchsia-700 text-white border-fuchsia-700", "bg-sky-700 text-white border-sky-700",
  "bg-stone-700 text-white border-stone-700",
];
const STYLES = [...PALETTE.map((c, i) => [c, DOTS[i]]), ...SOLID.map((c) => [c, "bg-white/80"])];
const FIXED = { apk: 0, "mission ready bundle": 1 };
const SPARE = STYLES.length - 2; // the two fixed colours stay unique to APK and bundles

// Colour by position in the shared type list, so listed types never clash until the palette runs out.
const indexFor = (type, order) => {
  const key = (type || "").trim().toLowerCase();
  if (key in FIXED) return FIXED[key];
  const others = order.filter((n) => !(n.trim().toLowerCase() in FIXED)).map((n) => n.trim().toLowerCase());
  const pos = others.indexOf(key);
  if (pos >= 0) return 2 + (pos % SPARE);
  let h = 0;
  for (const ch of key) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  return 2 + (h % SPARE);
};

export const TypeBadge = ({ type, order = [], testid }) => {
  const [cls, dot] = STYLES[indexFor(type, order)];
  return (
    <span className={`inline-flex max-w-full items-start gap-1.5 rounded-2xl border px-2.5 py-1 text-xs font-semibold leading-tight ${cls}`} data-testid={testid}>
      <span className={`mt-[0.3rem] h-1.5 w-1.5 shrink-0 rounded-full ${dot}`} aria-hidden="true" />
      <span className="break-words">{type || "No type"}</span>
    </span>
  );
};
